<template>
  <div id="app">
    <div v-cloak>
      <router-view/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
  };
</script>

<style>
  @import '../node_modules/bootstrap/dist/css/bootstrap.css';
  @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';

  [v-cloak] {
    display: none;
  }

  #app {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    font-family: 'Open Sans', serif;
    font-size: 1rem;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*margin-top: 60px;*/
  }

  html,
  body {
    height: 100%;
  }

</style>
